<template>
    <div class="ApplicantDetails ">
        <q-card flat bordered style="border: 1px solid #e9e9e9; border-radius: 1rem;">
            <q-card-section>
                <div class="text-bold" style="font-size: 16px;">{{$t("TacPage.title")}}</div>
            </q-card-section>
            <q-separator style="margin: 0 0.75rem; width: auto;"/>
            <q-card-section >

        <!-- <div class="row">
            <div class="col text-center">
                <q-chip square :label='$t("TacPage.title")'   color="primary" text-color="white"/>
            </div>
        </div> -->
        <q-form @submit="ConfirmTransaction" class="">
        <q-card flat style="border-radius:25px;">
            <!-- <div class="row justify-left text-left q-px-md">
                <div class="col text-bold" style="font-size: 16px;">
                    {{$t("TacPage.title2")}}
                </div>
            </div> -->
                <div class="row">

                    <div class="col-xs-12 col-md-3 text-right">
                        <div key="brandimage" class="text-center q-py-md">
                                <img src="@/assets/tac.png" width="120px" height="120px">
                            </div>
                    </div>
                    
                    <div class="col-xs-12 col-sm col-md text-left q-pa-sm">
                        <div class="row">
                            <div class="col">
                                <div class="text-bold q-mb-sm" style="font-size: 14px;">{{$t("TacPage.title3")}}</div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="q-mb-sm">{{$t("TacPage.content")}}</div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="">{{$t("TacPage.content2")}} <a class="">{{$t("TacPage.contentbtn")}}</a> {{$t("TacPage.content3")}}</div>
                            </div>
                        </div>

                        <!-- TAC Input -->
                        
                        <div class="row justify-start q-pt-md">
                            <div class="col-xs-12 col-md-8 ">
                            <!--  <q-input type="password" v-model="StoreStateAD.TAC_code" class="" filled lazy-rulesss :rules="[val => !!val || '' + $t('TacPage.entertac') +' ']"  :label='$t("TacPage.entertac")' />
                            -->
                            {{$t("TacPage.entertac")}}
                            <q-input v-model="StoreStateAD.TAC_code" outlined :type="isPwd ? 'password' : 'text'" lazy-rulesss :rules="[val => !!val || '' + $t('TacPage.entertac') +' ']" >
                                <template v-slot:append>
                                <q-icon
                                    :name="isPwd ? 'visibility_off' : 'visibility'"
                                    class="cursor-pointer"
                                    @click="isPwd = !isPwd"
                                />
                                </template>
                            </q-input>
                            <a href="#" @click="reTriggerTac()" class="text-primary">
                                {{$t("TacPage.resend")}}
                                </a>
                            </div>
                        </div>

                        <div class="row justify-start q-pt-md" >
                                    <!-- Navigation 
                                    :ShowSubmitButton=true
                                    SubmitButtonColor="primary"
                                    @SubmitButton="ConfirmTransaction()"
                                /> -->
                                <q-btn unelevated type="submit" :label='$t("common.submit")' style="background: #ff6666 !important;" text-color="white"  @click="scrollPositionToTop" />
                        </div>

                    </div>
                    
                </div>
                <!-- <q-separator color="grey-7"/> -->
                
                
        </q-card>
        </q-form>
        <q-dialog v-model="StoreStateAD.OpenPopUp" :content-css="{minWidth: '60vw', minHeight: '80vh'}" no-backdrop-dismiss>
          <q-card style="min-width: 80%; border-radius: 1rem; font-family: 'Poppins', sans-serif;" class="q-pa-sm">
                <q-card-section>
                    <AD></AD>
                </q-card-section>
                <q-card-section v-if="$route.name==='AHAM Investment'||$route.name==='Redemption'">
                    <NOTICES ></NOTICES>
                </q-card-section>

                <q-card-section v-if="$route.name==='Switching'">
                    <NOTICES2 ></NOTICES2>
                </q-card-section>
                <q-card-section>
                     <div class="row justify-center" >
                           
                         <Navigation
                            class="navigationbtn"
                            :ShowDisagreeButton=true
                            @DisagreeButton="Cancel()"
                        />
                         <Navigation
                            class="navigationbtn"
                            v-if="$route.name=='AHAM Investment'"
                            :ShowAgreeButton=true
                            AgreeButtonColor="primary"
                            @AgreeButton="ConfirmReroute()"
                            
                        />
                        <Navigation
                            class="navigationbtn"
                            v-if="$route.name=='Redemption'"
                            :ShowAgreeButton=true
                            AgreeButtonColor="red"
                            @AgreeButton="confirmProcess()"
                            
                        />
                         <Navigation
                            class="navigationbtn"
                            v-if="$route.name=='Switching'"
                            :ShowAgreeButton=true
                            AgreeButtonColor="red"
                            @AgreeButton="confirmProcessSwitch()"
                        />
                </div>
                </q-card-section>
          </q-card>
        </q-dialog>      
        </q-card-section>
        </q-card>
    </div>
</template>
<script>

import { mapActions } from 'vuex';
import store from '../store';

import AD from '@/components/AccountDetails.vue'

import NOTICES2 from '@/components/Notice2.vue'
import NOTICES from '@/components/Notice.vue'
import Navigation from '@/components/NavigationButtons'
export default {
      name: 'ApplicantDetails',
      components : {
        Navigation,
        AD,
        NOTICES,
        NOTICES2
    },
      data () {
		return {
            StoreStateAD : store.state.AD,            
            StoreStateLookup : store.state.Lookup,
			StoreStateAOD : store.state.AOD,
            StoreStateLogin: store.state.Login,
            tempMobileNo:'',            
            IAkaunUrl : process.env.VUE_APP_IAKAUN_URL,
            doTacVerify: process.env.VUE_APP_TAC_VERIFY,            
            isPwd: true,
        }
    },
	mounted () {
        
    },
    computed: {},
    methods:{
        ...mapActions([
            "GetOnboardingSelf",
            "GetLookup",
           // "GeteMisLookup",
           "Logging",
            "RequestTAC",
            "TACVerification",
            "TransactRedeemProcess",
            "getTranactionApplicationEmis",
            "PostTransaction_Submit",
            "PostTransaction_Submit_RedeemSwitch"
        ]),
        scrollPositionToTop(){
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        },
        reTriggerTac:function () {
            //TO DO UNCOMMENT THIS REQUEST TAC
         
            if(this.doTacVerify === 'true'){
                // this.StoreStateAOD.ContactInformation.MobileNo  ='60149638728'
        
                this.formatMobileNo();
                    var tempval = ''
                    if(this.StoreStateAOD.PersonalInformation.NRIC!=''){
                        tempval = this.StoreStateAOD.PersonalInformation.NRIC;
                    }else if(this.StoreStateAOD.PersonalInformation.OldID!=''){
                        tempval = this.StoreStateAOD.PersonalInformation.OldID;
                    }

                    this.RequestTAC({
                        CustomerTelMobile : this.StoreStateAOD.ContactInformation.MobileNo,
                        MobileNoCode: this.StoreStateAOD.ContactInformation.MobileNoCode,
                        Purpose : 'EMIS - Account Verification',
                        CustomerId : tempval,
                        RIDType : ''
                    })
                    .then(res=>{
                    this.$store.dispatch('Logging',
                        {
                            typeid :'5', 
                            appid : '2',
                            str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + '  -> RequestTAC -> ' + this.StoreStateAOD.ContactInformation.MobileNo+' res:'+ res
                        });

                        if(res===true){
                            this.$q.dialog({
                                title :  this.$t("PopUp.tacheader") ,
                                message : this.$t("PopUp.tacbody") + this.tempMobileNo 
                            })
                        }else{
                            this.$q.dialog({
                                title :  'Warning',
                                message :  res
                            })
                        }
                    }) 
            }else{
                this.$q.dialog({
                    title :  this.$t("PopUp.tacheader") ,
                    message : this.$t("PopUp.tacbody") + this.tempMobileNo 
                })
            }   
       
        },
        ConfirmTransaction:function(){
          
            var tempval = ''
            if(this.StoreStateAOD.PersonalInformation.NRIC!=''){
                tempval = this.StoreStateAOD.PersonalInformation.NRIC;
            }else if(this.StoreStateAOD.PersonalInformation.OldID!=''){
                tempval = this.StoreStateAOD.PersonalInformation.OldID;
            }
            this.$q.loading.show({
             spinnerSize: 50
            })
            
            if(this.doTacVerify === 'true'){
                this.TACVerification({
                    CustomerId : tempval,
                    TAC: this.StoreStateAD.TAC_code,
                    Purpose: 'EMIS - Account Verification'
                }).then(res=>{

                    this.$store.dispatch('Logging',{
                        appid : '2',
                        typeid :'4', 
                        str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' TACVerification,  res - > '+  res 
                    });
                        
                    //res = true
                    if(res===false){
                            
                        this.$q.loading.hide()
                        this.$q.dialog({
                            title : 'Message',
                            message : 'Invald TAC.'  
                        })
                    }else if(res === true){

                        if(this.$route.name ==='AHAM Investment'){
                            
                            this.$q.loading.hide()

                            this.StoreStateAD.step = 7
                        }else{
                            this.PostTransaction_Submit_RedeemSwitch()
                                .then(res=>{

                                this.$store.dispatch('Logging',{
                                    appid : '2',
                                    typeid :'4', 
                                    str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' PostTransaction_Submit,  res - > '+  res 
                                });
                                    
                                this.$q.loading.hide()
                                if(res===true){

                                    this.StoreStateAD.SwitchingStep='3',
                                    this.StoreStateAD.RedemptionStep='3'                                
                                    this.StoreStateAD.TC_TransactionStatus = '0000'
                                }else{
                                    //this.StoreStateAD.step = 7
                                    this.StoreStateAD.SwitchingStep='3',
                                    this.StoreStateAD.RedemptionStep='3'               
                                    this.StoreStateAD.TC_TransactionStatus = '000'                        
                                    this.StoreStateAD.FailReasonTitle = res.toString()
                                }
                            })    
                        }
                                        
                    }else{
                        this.$q.loading.hide()
                        this.$q.dialog({
                            title : 'Message',
                            message : 'Invald TAC.'  
                        })
                    }
                })
            }else{
                if(this.$route.name ==='AHAM Investment'){

                    this.$q.loading.hide()
                    this.StoreStateAD.step = 7
                }else{
                    this.PostTransaction_Submit_RedeemSwitch()
                    .then(res=>{

                        this.$store.dispatch('Logging',{
                            appid : '2',
                            typeid :'4', 
                            str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' PostTransaction_Submit,  res - > '+  res 
                        });
                        
                        this.$q.loading.hide()
                        if(res===true){
                            //this.StoreStateAD.step = 7
                            this.StoreStateAD.SwitchingStep='3'
                            this.StoreStateAD.RedemptionStep='3'
                            this.StoreStateAD.TC_TransactionStatus = '0000'
                        }else{
                            //this.StoreStateAD.step = 7
                            this.StoreStateAD.SwitchingStep='3'
                            this.StoreStateAD.RedemptionStep='3'                        
                            this.StoreStateAD.TC_TransactionStatus = '000'                        
                            this.StoreStateAD.FailReasonTitle = res.toString()
                        }
                    })
                }

            }
        },
        Cancel:function(){
           window.location.href = this.IAkaunUrl
           // 'https://iakaunuat2.epf.gov.my/member/member/login'
        },
        ConfirmReroute: function(){
            this.StoreStateAD.OpenPopUp = false;
            this.StoreStateAD.step = 7
        },
        confirmProcess:function(){
           this.getTranactionApplicationEmis()
           .then(res=>{

                this.$store.dispatch('Logging',{
                    appid : '2',
                    typeid :'4', 
                    str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' getTranactionApplicationEmis,  res - > '+  res 
                });
                if(res===true){

                    this.reTriggerTac();
                    this.StoreStateAD.OpenPopUp = false;
                    this.StoreStateAD.RedemptionStep='2'
                    this.StoreStateAD.TC_TransactionStatus = '0000'
                }else{
                    this.$q.dialog({
                        title : 'Sorry',
                        message : res  
                    })

                    this.StoreStateAD.OpenPopUp = false;
                    this.StoreStateAD.RedemptionStep='2'
                    this.StoreStateAD.FailReasonTitle = res.toString()
                    this.StoreStateAD.TC_TransactionStatus = '000'
                }
            })
        },
        confirmProcessSwitch:function(){
           this.getTranactionApplicationEmis().then(res=>{

               this.$store.dispatch('Logging',{
                    appid : '2',
                    typeid :'4', 
                    str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' getTranactionApplicationEmis,  res - > '+  res 
                });
                
                  if(res===true){
                    this.reTriggerTac();
                    this.StoreStateAD.OpenPopUp = false;
                    this.StoreStateAD.SwitchingStep='2'
                    this.StoreStateAD.TC_TransactionStatus = '0000'
             
                    }else{
                        this.$q.dialog({
                            title : 'Sorry',
                            message : res  
                        })
                        this.StoreStateAD.OpenPopUp = false;
                        this.StoreStateAD.SwitchingStep='2'
                        this.StoreStateAD.TC_TransactionStatus = '000'                        
                        this.StoreStateAD.FailReasonTitle = res.toString()
                    }
                })
        },
        formatMobileNo:function() {

        //this.StoreStateAOD.ContactInformation.MobileNo  ='60149638728'
        var mobileNo = this.StoreStateAOD.ContactInformation.MobileNo       
        this.tempMobileNo =  '01x- xxxx ' + mobileNo.slice(-4) ;
      }
    }
}
</script>

<style lang="stylus">
.navigationbtn
    margin: 10px 10px 10px 10px;

.g_header
    padding-left: 35px
    padding-top: 30px
    padding-bottom: 10px
    font-size: 20px
    font-family: 'Cabin', sans-serif
    font-weight: 700

.g_text
    padding-left: 35px
    font-size: 15px
    font-family: 'Cabin', sans-serif
    font-weight: 300

.g_retry
    padding-left: 35px
    font-size: 15px
    font-family: 'Cabin', sans-serif
    font-weight: 150
</style>